import React, { useState, useEffect } from 'react';
import Header from '../../layouts/Header';
import { Button, Col, Dropdown, Form, FormControl, InputGroup, Modal, Row, Spinner, Badge } from 'react-bootstrap';
import ReusableTable from '../../components/ReusableTable';
import { toast } from 'react-toastify';
import axiosInstance from '../../api/axios';import makeAnimated from "react-select/animated";
import Select from "react-select";
import { useSelector } from 'react-redux';
import { Search, Filter } from 'react-bootstrap-icons';

const PopupAdvertisement = () => {

    const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
    const [skin, setSkin] = useState(currentSkin);
    const { access } = useSelector((state) => state.login);
    const { loginEmail } = useSelector((state) => state.login);
    const email = loginEmail || localStorage.getItem("email");
    const [addAccess, setAddAccess] = useState([]);

    useEffect(() => {
        if (Array.isArray(access)) {
            const filteredAccess = access?.filter((perm) =>
                perm?.startsWith("PopupAdvertisement:")
            );
            setAddAccess(filteredAccess);
        }
    }, [access]);

    const accessToken = localStorage.getItem("authToken");
    const animatedComponents = makeAnimated();
    const [openAddModal, setOpenAddModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [openImageModal, setOpenImageModal] = useState(false);
    const [openImageUploadModal, setOpenImageUploadModal] = useState(false)
    const [searchText, setSearchText] = useState('');
    const [popUpData, setPopUpData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [inputData, setInputData] = useState({
        title: '',
        isSplashScreenAd: false,
        isSubscriptionAd: false,
        redirectTo: ''
    });
    const [editedData, setEditedData] = useState({});
    const [selectedExcludedOutlets, setSelectedExcludedOutlets] = useState([]);
    const [selectedEditedExcludedOutlets, setSelectedEditedExcludedOutlets] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState('');
    const [selectedEditProduct, setSelectedEditProduct] = useState('');
    const [outlets, setOutlets] = useState([]);
    const [productsList, setProductsList] = useState([]);
    const [image, setImage] = useState(null);
    const [editImage, setEditImage] = useState(null);
    const [isAddBtnLoading, setIsAddBtnLoading] = useState(false);
    const [isEditBtnLoading, setIsEditBtnLoading] = useState(false);
    const [isDeleteBtnLoading, setIsDeleteBtnLoading] = useState(false);
    const [isImageEditBtnLoading, setIsImageEditBtnLoading] = useState(false);
    const [advertisementId, setAdvertisementId] = useState('');
    const [selectedImage, setSelectedImage] = useState(null);
    const [editImageId, setEditImageId] = useState('');
    const [pagination, setPagination] = useState({ page: 1, rowsPerPage: 10 });
    const [searchTerm, setSearchTerm] = useState('');
    
    // Filter states
    const [statusFilter, setStatusFilter] = useState('');
    const [splashScreenFilter, setSplashScreenFilter] = useState('');
    const [appliedFilters, setAppliedFilters] = useState({});

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            width: "100%",
            borderRadius: "4px",
            minWidth: "160px",
            fontSize: "0.875rem",
            minHeight: "32px",
            borderColor: state.isFocused ? "#80bdff" : "#ced4da",
            boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : null,
            "&:hover": {
                borderColor: state.isFocused ? "#80bdff" : "#ced4da",
            },
        }),
        placeholder: (provided) => ({
            ...provided,
            color: "#6c757d",
            fontSize: "0.875rem",
        }),
        menu: (provided) => ({
            ...provided,
            fontSize: "0.875rem",
        }),
        option: (provided) => ({
            ...provided,
            fontSize: "0.875rem",
            padding: "4px 8px",
        }),
        multiValue: (provided) => ({
            ...provided,
            fontSize: "0.75rem",
        }),
        multiValueLabel: (provided) => ({
            ...provided,
            fontSize: "0.75rem",
            padding: "2px 4px",
        }),
    };

    const columns = [
        { 
            header: "Sr.No", 
            accessor: "serialNumber",
            headerStyle: { fontSize: '0.85rem' },
            cellStyle: { fontSize: '0.85rem' }
        },
        {
            header: "Title",
            accessor: "title",
            headerStyle: { fontSize: '0.85rem' },
            cellStyle: { fontSize: '0.85rem' },
            render: (value, row) => (
                <div className="d-flex flex-column align-items-center gap-1">
                    {row?.advertisementImage?.match(/\.(mp4|webm|ogg|mov)$/i) ? (
                        <video
                            style={{
                                height: "60px",
                                width: "60px",
                                borderRadius: "50%",
                                border: "0.2px solid blueviolet",
                                cursor: "pointer",
                                objectFit: "cover"
                            }}
                            src={row?.advertisementImage}
                            onClick={() => handleImageClick(row)}
                        />
                    ) : (
                        <img
                            style={{
                                height: "60px",
                                width: "60px",
                                borderRadius: "50%",
                                border: "0.2px solid blueviolet",
                                cursor: "pointer",
                                objectFit: "cover"
                            }}
                            src={row?.advertisementImage || "/dummy-image.png"}
                            alt="category-image"
                            onClick={() => handleImageClick(row)}
                        />
                    )}
                    <span className='fw-semibold' style={{ color: 'purple', fontSize: '0.85rem' }}>{row?.title}</span>
                    <span className="text-secondary" style={{ fontSize: '0.7rem' }}>
                        {row.createdAt
                            ? new Date(row.createdAt).toLocaleString("en-US", {
                                year: "numeric",
                                month: "short",
                                day: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                            })
                            : "--------"
                        }
                    </span>
                    {/* <Badge 
                        bg={row.redirectTo === 'PRODUCT' ? 'success' : 
                             row?.redirectTo === 'MENU' ? 'primary' : 
                             row?.redirectTo === 'SUBSCRIPTION' ? 'warning' : 'secondary'}
                        style={{ fontSize: '0.65rem', width: 'fit-content' }}
                    >
                        {row.redirectTo === "PRODUCT" ? "PRODUCT_SCREEN" : 
                         row.redirectTo === "MENU" && row?.isSplashScreenAd === false ? "MENU_SCREEN" : 
                         row.redirectTo === "SUBSCRIPTION" ? "SUBSCRIPTION_SCREEN" : 
                         row.isSplashScreenAd ? "SPLASH_SCREEN_AD" : "PROFILE_SCREEN"}
                    </Badge> */}
                </div>
            ),
        },
        // {
        //     header: "Image", 
        //     accessor: "phone",
        //     headerStyle: { fontSize: '0.85rem' },
        //     cellStyle: { fontSize: '0.85rem' },
        //     render: (value, row) => (
        //         <div className="d-flex flex-column align-items-center gap-2">
        //             {row?.advertisementImage?.match(/\.(mp4|webm|ogg|mov)$/i) ? (
        //                 <video
        //                     style={{
        //                         height: "60px",
        //                         width: "60px",
        //                         borderRadius: "50%",
        //                         border: "0.2px solid blueviolet",
        //                         cursor: "pointer",
        //                         objectFit: "cover"
        //                     }}
        //                     src={row?.advertisementImage}
        //                     onClick={() => handleImageClick(row)}
        //                 />
        //             ) : (
        //                 <img
        //                     style={{
        //                         height: "60px",
        //                         width: "60px",
        //                         borderRadius: "50%",
        //                         border: "0.2px solid blueviolet",
        //                         cursor: "pointer",
        //                         objectFit: "cover"
        //                     }}
        //                     src={row?.advertisementImage || "/dummy-image.png"}
        //                     alt="category-image"
        //                     onClick={() => handleImageClick(row)}
        //                 />
        //             )}
        //         </div>
        //     )
        // },
        {
            header: "Screen",
            accessor: "redirectTo",
            headerStyle: { fontSize: '0.85rem' },
            cellStyle: { fontSize: '0.85rem' },
            render: (value, row) => (
                <div style={{ fontSize: '0.85rem' }}>
                    <Badge 
                        bg={row.redirectTo === 'PRODUCT' ? 'success' : 
                             row?.redirectTo === 'MENU' ? 'primary' : 
                             row?.redirectTo === 'SUBSCRIPTION' ? 'warning' : 'secondary'}
                        style={{ fontSize: '0.65rem', width: 'fit-content' }}
                    >
                        {row.redirectTo === "PRODUCT" ? "PRODUCT_SCREEN" : 
                         row.redirectTo === "MENU" && row?.isSplashScreenAd === false ? "MENU_SCREEN" : 
                         row.redirectTo === "SUBSCRIPTION" ? "SUBSCRIPTION_SCREEN" : 
                         row.isSplashScreenAd ? "SPLASH_SCREEN_AD" : "PROFILE_SCREEN"}
                    </Badge>
                </div>
            ),
        },
        {
            header: "Product Name",
            accessor: "city",
            headerStyle: { fontSize: '0.85rem' },
            cellStyle: { fontSize: '0.85rem' },
            render: (value, row) => (
                <div style={{ fontSize: '0.85rem' }}>
                    {row?.productId?.name ? row?.productId?.name : "No Product Allocated"}
                </div>
            ),
        },
        {
            header: "Excluded Outlets",
            accessor: "state",
            headerStyle: { fontSize: '0.85rem' },
            cellStyle: { fontSize: '0.85rem' },
            render: (value, row) => (
                <div style={{ fontSize: '0.8rem' }}>
                    {row.excludedOutlets && row.excludedOutlets.length > 0
                        ? row.excludedOutlets.map(outlet => outlet.name.toLowerCase().trim()).slice(0, 2).join(', ') 
                        + (row.excludedOutlets.length > 2 ? ` +${row.excludedOutlets.length - 2} more` : '')
                        : "No outlets excluded"}
                </div>
            ),
        },
        {
            header: "Status",
            accessor: "status",
            headerStyle: { fontSize: '0.85rem' },
            cellStyle: { fontSize: '0.85rem' },
            render: (value, row) => (
                <Badge
                    bg={row?.isActive === true ? "success" : "danger"}
                    style={{ fontSize: '0.7rem' }}
                >
                    {row?.isActive === true ? "ACTIVE" : "INACTIVE"}
                </Badge>
            ),
        },
        {
            header: "Actions",
            accessor: null,
            headerStyle: { fontSize: '0.85rem' },
            cellStyle: { fontSize: '0.85rem' },
            render: (_, row) => (
                <div className="d-flex justify-content-center">
                    <Dropdown>
                        <Dropdown.Toggle variant="link" className="p-0 m-0 border-0">
                            <i className="ri-more-2-fill" style={{ cursor: "pointer", fontSize: '1rem' }}></i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu align="end" style={{ fontSize: '0.8rem' }}>
                            {(addAccess?.includes("PopupAdvertisement:update") || email === "contact@xpansecafe.com") && (
                                <Dropdown.Item
                                    className="text-primary"
                                    onClick={() => handleOpenEditModal(row)}
                                    style={{ fontSize: '0.8rem', padding: '0.25rem 1rem' }}
                                >
                                    Edit
                                </Dropdown.Item>
                            )}
                            {(addAccess?.includes("PopupAdvertisement:get") || email === "contact@xpansecafe.com") && (
                                <Dropdown.Item
                                    className="text-success"
                                    onClick={() => handleOpenViewModal(row)}
                                    style={{ fontSize: '0.8rem', padding: '0.25rem 1rem' }}
                                >
                                    View
                                </Dropdown.Item>
                            )}
                            {(addAccess?.includes("PopupAdvertisement:delete") || email === "contact@xpansecafe.com") && (
                                <Dropdown.Item
                                    className="text-danger"
                                    onClick={() => handleOpenDeleteModal(row)}
                                    style={{ fontSize: '0.8rem', padding: '0.25rem 1rem' }}
                                >
                                    Delete
                                </Dropdown.Item>
                            )}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            ),
        },
    ];

    const outletData = outlets?.map((outlet) => ({
        value: outlet._id,
        label: `${outlet.name} (${outlet.city})`,
    }));

    const getInAppAddvertisement = async (filters = {}) => {
        setLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }

            // Build query parameters
            let queryParams = new URLSearchParams();
            
            if (filters.status) {
                queryParams.append('status', filters.status);
            }
            
            if (filters.isSplashScreenAd !== undefined && filters.isSplashScreenAd !== '') {
                queryParams.append('isSplashScreenAd', filters.isSplashScreenAd);
            }

            const url = `in-app-advertisement${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
            
            const response = await axiosInstance.get(url, { headers });
            
            response?.data?.data?.inAppAdvertisement?.forEach((item, index) => {
                item.serialNumber = index + 1;
            });
            
            let list = response?.data?.data?.inAppAdvertisement;
            let newList = list?.reverse() || [];

            setPopUpData(newList);
            setFilteredData(newList);
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setLoading(false);
        }
    };

    const handleApplyFilters = () => {
        const filters = {};
        if (statusFilter) filters.status = statusFilter;
        if (splashScreenFilter !== '') filters.isSplashScreenAd = splashScreenFilter;
        
        setAppliedFilters(filters);
        getInAppAddvertisement(filters);
    };

    const handleClearFilters = () => {
        setStatusFilter('');
        setSplashScreenFilter('');
        setAppliedFilters({});
        getInAppAddvertisement({});
    };

    const getOutlets = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axiosInstance.get("outlet", { headers });

            if (response?.data?.status === true) {

                let filteredOutlets = response?.data?.data?.outlets?.filter((act) => act?.status === "ACTIVE");

                setOutlets(filteredOutlets);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const getProductsList = async (id) => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axiosInstance.get("product", { headers });
            if (response?.data?.status === true) {
                setProductsList(response?.data?.data?.products);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const handleOpenAddModal = () => {
        setOpenAddModal(true);
    }

    const handleCloseAddModal = () => {
        setOpenAddModal(false);
        setSelectedProduct('');
        setSelectedExcludedOutlets([]);
        setInputData({
            title: "",
            redirectTo: "",
            isSplashScreenAd: false,
            isSubscriptionAd: false,
        });
        setImage(null);
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInputData((prevData) => ({ ...prevData, [name]: value }));
    }

    const handleImageChange = (e) => {
        const allowedExtensions = ["png", "jpg", "jpeg", "webp", "gif", "PNG", "JPG", "JPEG", "WEBP", "GIF", "mp4", "mov", "avi", "mkv", "webm"];
        
        const selectedFile = e.target.files[0];

        if (selectedFile) {
            const extension = selectedFile.name.split(".").pop().toLowerCase();
            if (!allowedExtensions.includes(extension)) {
                toast.error("Invalid file format. Upload only images (png, jpg, jpeg, webp, gif) or videos (mp4, mov, avi, mkv, webm).", {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                return;
            } else {
                setImage(selectedFile);
            }
        }
    };

    const handleSelectChange = (selected) => {
        setSelectedExcludedOutlets(selected);
    };

    const handleSelectProductChange = (selected) => {
        setSelectedProduct(selected);
    };

    const handleSubmit = async (e) => {
        setIsAddBtnLoading(true);
        e.preventDefault();
        
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'multipart/form-data'
            }
            const formData = new FormData();

            let selectedOutlets = selectedExcludedOutlets?.map((out) => out?.value);

            let newInputData = {
                ...inputData,
                excludedOutlets: selectedOutlets,
                productId: selectedProduct?.value
            }

            formData.append('title', newInputData.title);

            formData.append(
                'isSubscriptionAd',
                newInputData.isSubscriptionAd ? 'true' : 'false'
            );
            
            if (newInputData.productId) {
                formData.append('productId', newInputData.productId);
            }
            
            formData.append('advertisementImage', image);

            if (newInputData?.redirectTo) {
                formData.append('redirectTo', newInputData?.redirectTo);                
            }

            formData.append('isSplashScreenAd', newInputData?.isSplashScreenAd);

            if (selectedOutlets?.length > 0) {
                selectedOutlets?.forEach((outlet, index) => {
                    formData.append(`excludedOutlets[${index}]`, outlet);
                });
            }

            const response = await axiosInstance.post('in-app-advertisement', formData, { 
                headers
            });
            
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                e.target.reset();
                getInAppAddvertisement(appliedFilters);
                setSelectedProduct('');
                setSelectedExcludedOutlets([]);
                setInputData({
                    title: "",
                    redirectTo: "",
                    isSplashScreenAd: false,
                    isSubscriptionAd: false
                });
                setImage(null);
                setOpenAddModal(false);
            }

        } catch (error) {
            if (error?.response) {
                let errorMessage = '';
                if (
                    error.response?.status === 406
                ) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
                }
                else if (
                    error.response?.status === 412
                ) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error
                } else if (error?.response?.status === 404) {
                    errorMessage = error?.response?.data?.error
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsAddBtnLoading(false);
        }
    };

    const handleOpenEditModal = (data) => {
        console.log("Handle Open Edit Modal :", data);
        
        setOpenEditModal(true);
        setEditedData({
            title: data?.title,
            isActive: data?.isActive,
            isSubscriptionAd: data?.isSubscriptionAd,
            isSplashScreenAd: data?.isSplashScreenAd ? data?.isSplashScreenAd : false,
            redirectTo: data?.redirectTo,
            _id: data?._id
        })
        setSelectedEditProduct(
            data?.productId ? { value: data.productId._id, label: data.productId.name } : null
        );
        let selectedExOutlet = data?.excludedOutlets;
        let mappedSelectedExOutlet = selectedExOutlet?.map((m) =>
        ({
            value: m?._id,
            label: m?.name
        }))
        setSelectedEditedExcludedOutlets(mappedSelectedExOutlet);
    };

    const handleCloseEditModal = () => {
        setOpenEditModal(false);
        setEditedData({});
        setSelectedEditProduct(null);
        setSelectedEditedExcludedOutlets([]);
    };

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setEditedData((prevData) => ({ ...prevData, [name]: value }))
    };

    const handleEditSelectChange = (selected) => {
        setSelectedEditedExcludedOutlets(selected);
    };

    const handleEditSelectProductChange = (selected) => {
        setSelectedEditProduct(selected);
    };

    const handleEditSubmit = async (e) => {
        e.preventDefault();
        setIsEditBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'multipart/form-data'
            }

            const selectedEditOutlets = selectedEditedExcludedOutlets?.map((out) => out?.value) || [];

            let newEditedData = {
                ...editedData,
                excludedOutlets: selectedEditOutlets.length > 0 ? selectedEditOutlets : null,
                productId: selectedEditProduct?.value
            }

            const formData = new FormData();
            formData.append('_id', newEditedData._id);
            formData.append('title', newEditedData.title);
            formData.append('isActive', newEditedData.isActive);
            if (newEditedData.isSplashScreenAd === true) {
                formData.append('isSplashScreenAd', newEditedData.isSplashScreenAd);            
            }
            
            if (newEditedData.redirectTo) {
                formData.append('redirectTo', newEditedData.redirectTo);
            }
            
            if (newEditedData.productId) {
                formData.append('productId', newEditedData.productId);
            } else {
                formData.append('productId', null);
            }
            formData.append('isSubscriptionAd', newEditedData.isSubscriptionAd);

            if (selectedEditOutlets.length > 0) {
                selectedEditOutlets.forEach((outlet, index) => {
                    formData.append(`excludedOutlets[${index}]`, outlet);
                });
            } else {
                formData.append('excludedOutlets', 'null');
            }

            const response = await axiosInstance.put('in-app-advertisement', formData, { headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
                getInAppAddvertisement(appliedFilters);
                setOpenEditModal(false);
            }
        } catch (error) {
            console.log("Error In Updating :", error);
            
            if (error?.response) {
                let errorMessage = '';
                if (error.response?.status === 406) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error;
                }
                else if (error.response?.status === 412) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 404) {
                    errorMessage = error?.response?.data?.data?.message || error?.response?.data?.error;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error;
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }
        } finally {
            setIsEditBtnLoading(false);
        }
    };

    const handleSearchChange = (e) => {
        setSearchText(e.target.value);
    };

    const handleImageClick = (data) => {
        setOpenImageModal(true);
        setSelectedImage(data);
    };

    const handleCloseImageModal = () => {
        setOpenImageModal(false);
    };

    const handleImageUploadModal = (data) => {
        setEditImage(data?.advertisementImage);
        setEditImageId(data?._id);
        setOpenImageUploadModal(true);
        setOpenImageModal(false);
    };

    const handleEditImageChange = (e) => {
        const allowedExtensions = ["png", "jpg", "jpeg", "webp", "gif", "mp4", "mov", "avi", "mkv", "webm"];
        const selectedFile = e.target.files[0];

        if (selectedFile) {
            const extension = selectedFile.name.split(".").pop().toLowerCase();
            if (!allowedExtensions.includes(extension)) {
                toast.error("Invalid file format. Upload only images (png, jpg, jpeg, webp, gif) or videos (mp4, mov, avi, mkv, webm).", {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                return;
            } else {
                setEditImage(selectedFile);
            }
        }
    };

    const handleEditImage = async (e) => {
        e.preventDefault();
        setIsImageEditBtnLoading(true);
        try {
            const formData = new FormData();
            formData.append("advertisementImage", editImage);
            formData.append("_id", editImageId);

            const headers = {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${accessToken}`,
            };

            const response = await axiosInstance.put(
                "in-app-advertisement",
                formData,
                { headers }
            );

            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                getInAppAddvertisement(appliedFilters);
                setOpenImageUploadModal(false);
            }
        } catch (error) {
            if (error?.response?.status === 404) {
                toast.error(error.response.data.error, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response?.data?.data?.message;

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsImageEditBtnLoading(false);
        }
    };

    const handleOpenViewModal = (data) => {

    };

    const handleOpenDeleteModal = (data) => {
        setOpenDeleteModal(true);
        setAdvertisementId(data?._id);
    };

    const handleCloseDeleteModal = () => {
        setOpenDeleteModal(false);
    };

    const handleDeletePopup = async (e) => {
        e.preventDefault();
        setIsDeleteBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }
            const response = await axiosInstance.delete(`in-app-advertisement?_id=${advertisementId}`, { headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
                getInAppAddvertisement(appliedFilters);
                setOpenDeleteModal(false);
            }
        } catch (error) {
            if (error.response.status === 403) {
                toast.error(error?.response?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }

            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }
        } finally {
            setIsDeleteBtnLoading(false);
        }
    };

    const handlePageChange = (page) => {
        setPagination({ ...pagination, page });
    };

    const handleRowsPerPageChange = (rowsPerPage) => {
        setPagination({ page: 1, rowsPerPage });
    };

    const getPaginatedData = () => {
        const startIndex = (pagination?.page - 1) * pagination?.rowsPerPage;
        const endIndex = startIndex + pagination?.rowsPerPage;
        return filteredData?.slice(startIndex, endIndex);
    };

    const handleSubmitSearch = () => {
        const lowerSearch = searchText.toLowerCase();
        const result = popUpData?.filter((item) => {
            return (
                item?.title?.toLowerCase()?.includes(lowerSearch) ||
                item?.productId?.name?.toLowerCase()?.includes(lowerSearch)
            );
        });
        setFilteredData(result);
    }

    useEffect(() => {
        getInAppAddvertisement();
        getOutlets();
        getProductsList();
    }, []);

    useEffect(() => {
        if (!searchText) {
            setFilteredData(popUpData);
            return;
        }

        const lowerSearch = searchText.toLowerCase();

        const result = popUpData?.filter((item) => {
            return (
                item?.title?.toLowerCase()?.includes(lowerSearch) ||
                item?.productId?.name?.toLowerCase()?.includes(lowerSearch)
            );
        });

        setFilteredData(result);
    }, [searchText, popUpData]);

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className="main main-app p-2 p-lg-3">
                <div
                    className="container-fluid shadow-sm"
                    style={{ backgroundColor: "white", borderRadius: "4px" }}
                >
                    <Row className="pt-3">
                        <Col>
                            <h6 className="fw-semibold mb-0" style={{ fontSize: '1.2rem' }}>POPUP ADVERTISEMENT MANAGEMENT</h6>
                        </Col>
                        <hr className="mt-2 mb-2" />
                    </Row>

                    <Row className="mb-2 align-items-end">
                        <Col lg="4">
                            <Form.Group>
                                <Form.Label className="fw-semibold" style={{ fontSize: '0.8rem' }}>
                                    Search
                                </Form.Label>
                                <InputGroup 
                                    // size="sm"
                                >
                                    <FormControl
                                        placeholder="Search by title or product..."
                                        value={searchText}
                                        onChange={(e) => setSearchText(e.target.value)}
                                        style={{ fontSize: '0.8rem' }}
                                    />
                                    <Button variant="primary" 
                                        // size="sm" 
                                        onClick={handleSubmitSearch}
                                    >
                                        <Search size={14} /> Search
                                    </Button>
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        
                        <Col lg="2">
                            <Form.Group>
                                <Form.Label className="fw-semibold" style={{ fontSize: '0.8rem' }}>
                                    Status Filter
                                </Form.Label>
                                <Form.Select 
                                    // size="sm"
                                    value={statusFilter}
                                    onChange={(e) => setStatusFilter(e.target.value)}
                                    style={{ fontSize: '0.8rem' }}
                                >
                                    <option value="">All Status</option>
                                    <option value="ACTIVE">Active</option>
                                    <option value="INACTIVE">Inactive</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        
                        <Col lg="2">
                            <Form.Group>
                                <Form.Label className="fw-semibold" style={{ fontSize: '0.8rem' }}>
                                    Splash Screen
                                </Form.Label>
                                <Form.Select 
                                    // size="sm"
                                    value={splashScreenFilter}
                                    onChange={(e) => setSplashScreenFilter(e.target.value)}
                                    style={{ fontSize: '0.8rem' }}
                                >
                                    <option value="">All</option>
                                    <option value="true">Yes</option>
                                    <option value="false">No</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        
                        <Col lg="2" className="d-flex gap-1">
                            <Button 
                                variant="primary" 
                                // size="sm" 
                                onClick={handleApplyFilters}
                                style={{ fontSize: '0.8rem', marginTop: '22px' }}
                            >
                                <Filter size={14} className="me-1" />
                                Apply Filters
                            </Button>
                            <Button 
                                variant="outline-secondary" 
                                // size="sm" 
                                onClick={handleClearFilters}
                                style={{ fontSize: '0.8rem', marginTop: '22px' }}
                            >
                                Clear
                            </Button>
                        </Col>
                        
                        <Col lg="2" className="d-flex justify-content-end">
                            {(addAccess?.includes("PopupAdvertisement:add") || email === "contact@xpansecafe.com") && (
                                <Button
                                    variant="warning"
                                    // size="sm"
                                    className="fw-semibold w-75"
                                    onClick={handleOpenAddModal}
                                    style={{ fontSize: '0.8rem', marginTop: '22px' }}
                                >
                                    <i className="ri-add-line" style={{ marginRight: "3px", fontSize: '0.8rem' }}></i>
                                    Add New
                                </Button>
                            )}
                        </Col>
                    </Row>

                    <Row className='mt-4'>
                        <Col>
                            {(addAccess?.includes("PopupAdvertisement:get") || email === "contact@xpansecafe.com") && (
                                <ReusableTable
                                    columns={columns}
                                    data={getPaginatedData()}
                                    rowKey="serialNumber"
                                    loading={loading}
                                    currentPage={pagination.page}
                                    recordsPerPage={pagination.rowsPerPage}
                                    onPageChange={handlePageChange}
                                    totalPages={Math.ceil(filteredData.length / pagination.rowsPerPage)}
                                    onRecordsPerPageChange={handleRowsPerPageChange}
                                    tableClassName="table-sm"
                                />
                            )}
                        </Col>
                    </Row>

                    {openAddModal && (
                        <Modal
                            show={openAddModal}
                            onHide={handleCloseAddModal}
                            size="lg"
                            centered
                            aria-labelledby="vertically-centered-modal"
                            backdrop="static"
                        >
                            <Modal.Header closeButton style={{ padding: '0.75rem 1rem' }}>
                                <Modal.Title id="vertically-centered-modal" style={{ fontSize: '1.2rem' }}>
                                    ADD POP-UP ADVERTISEMENT
                                </Modal.Title>
                            </Modal.Header>
                            <Form onSubmit={handleSubmit}>
                                <Modal.Body style={{ padding: '1rem' }}>
                                    <Row className="mb-2">
                                        <Col md={6}>
                                            <Form.Group controlId="popupTitle">
                                                <Form.Label className="fw-semibold" style={{ fontSize: '0.8rem' }}>
                                                    Pop-Up Title <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Pop-up Title"
                                                    name="title"
                                                    value={inputData.title}
                                                    onChange={handleChange}
                                                    required
                                                    // size="sm"
                                                    style={{ fontSize: '0.8rem' }}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6} lg={6}>
                                            <Form.Group>
                                                <Form.Label className='fw-semibold' style={{ fontSize: '0.8rem' }}>
                                                    Show On Splash Screen <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Select
                                                    name="isSplashScreenAd"
                                                    value={inputData.isSplashScreenAd || ""}
                                                    onChange={handleChange}
                                                    required
                                                    // size="sm"
                                                    style={{ fontSize: '0.8rem' }}
                                                >
                                                    <option value="" disabled>Select</option>
                                                    <option value="true">YES</option>
                                                    <option value="false">NO</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>

                                        {inputData?.isSplashScreenAd === 'false' && (
                                            <>
                                                <Col md={6} lg={6} className='mt-2'>
                                                    <Form.Group>
                                                        <Form.Label className='fw-semibold' style={{ fontSize: '0.8rem' }}>
                                                            Take to <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <Form.Select
                                                            name="redirectTo"
                                                            value={inputData.redirectTo || ""}
                                                            onChange={handleChange}
                                                            required
                                                            // size="sm"
                                                            style={{ fontSize: '0.8rem' }}
                                                        >
                                                            <option value="" disabled>Select</option>
                                                            <option value="SUBSCRIPTION">SUBSCRIPTION_SCREEN</option>
                                                            <option value="PRODUCT">PRODUCT_SCREEN</option>
                                                            <option value="MENU">MENU_SCREEN</option>
                                                            <option value="PROFILE">PROFILE_SCREEN</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>

                                                {inputData?.redirectTo === 'SUBSCRIPTION' && (
                                                    <Col md={6} lg={6} className='mt-2'>
                                                        <Form.Group>
                                                            <Form.Label className='fw-semibold' style={{ fontSize: '0.8rem' }}>
                                                                Make Subscription Ad <span className="text-danger">*</span>
                                                            </Form.Label>
                                                            <Form.Select
                                                                name="isSubscriptionAd"
                                                                value={inputData.isSubscriptionAd}
                                                                onChange={handleChange}
                                                                required
                                                                // size="sm"
                                                                style={{ fontSize: '0.8rem' }}
                                                            >
                                                                <option value="" disabled>Select</option>
                                                                <option value="true">Yes</option>
                                                                <option value="false">No</option>
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                )}

                                                <Col md={6} className='mt-2'>
                                                    <Form.Group controlId="selectMenu">
                                                        <Form.Label className="fw-semibold" style={{ fontSize: '0.8rem' }}>
                                                            Select Product <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <Select
                                                            options={productsList?.map((rm) => ({
                                                                value: rm?._id,
                                                                label: rm?.name,
                                                            }))}
                                                            isDisabled={inputData.redirectTo !== 'PRODUCT'}
                                                            name="productId"
                                                            value={selectedProduct}
                                                            onChange={handleSelectProductChange}
                                                            classNamePrefix="react-select"
                                                            isClearable
                                                            placeholder="Select Product"
                                                            required={inputData.redirectTo === 'PRODUCT'}
                                                            styles={customStyles}
                                                        />
                                                    </Form.Group>
                                                </Col>

                                                <Col className='mt-2' md={6}>
                                                    <Form.Group controlId="excludedOutlets">
                                                        <Form.Label className="fw-semibold" style={{ fontSize: '0.8rem' }}>
                                                            Excluded Outlets
                                                        </Form.Label>
                                                        <Select
                                                            isMulti
                                                            components={animatedComponents}
                                                            value={selectedExcludedOutlets}
                                                            onChange={handleSelectChange}
                                                            options={outletData}
                                                            styles={customStyles}
                                                            placeholder="Select Excluded Outlets"
                                                            closeMenuOnSelect={false}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </>
                                        )}
                                    
                                        <Col md={6} className='mt-2'>
                                            <Form.Group controlId="popupImage">
                                                <Form.Label className="fw-semibold" style={{ fontSize: '0.8rem' }}>
                                                    Choose File <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="file"
                                                    onChange={handleImageChange}
                                                    accept="image/*,video/*"
                                                    required
                                                    // size="sm"
                                                    style={{ fontSize: '0.8rem' }}
                                                />
                                                <Form.Text className="text-muted" style={{ fontSize: '0.7rem' }}>
                                                    Supported formats: Images (png, jpg, jpeg, webp, gif) and Videos (mp4, mov, avi, mkv, webm)
                                                </Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Modal.Body>
                                <Modal.Footer style={{ padding: '0.75rem 1rem' }}>
                                    <Button variant="secondary" 
                                        // size="sm" 
                                        onClick={handleCloseAddModal} 
                                        style={{ fontSize: '0.8rem' }}
                                    >
                                        Cancel
                                    </Button>
                                    <Button variant="primary" 
                                        // size="sm" 
                                        className="fw-semibold" type='submit' style={{ fontSize: '0.8rem' }}
                                    >
                                        {isAddBtnLoading ? <Spinner size='sm' /> : 'ADD'}
                                    </Button>
                                </Modal.Footer>
                            </Form>
                        </Modal>
                    )}

                    {openEditModal && (
                        <Modal
                            show={openEditModal}
                            onHide={handleCloseEditModal}
                            size="lg"
                            centered
                            aria-labelledby="edit-popup-modal"
                            backdrop="static"
                        >
                            <Modal.Header closeButton style={{ padding: '0.75rem 1rem' }}>
                                <Modal.Title style={{ fontSize: '1.2rem' }}>UPDATE POP-UP ADVERTISEMENT</Modal.Title>
                            </Modal.Header>
                            <Form onSubmit={handleEditSubmit}>
                                <Modal.Body style={{ padding: '1rem' }}>
                                    <Row className="mb-2">
                                        <Col md={6}>
                                            <Form.Group controlId="editPopupTitle">
                                                <Form.Label className="fw-semibold" style={{ fontSize: '0.8rem' }}>
                                                    Pop-Up Title <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Pop-up Title"
                                                    name="title"
                                                    value={editedData.title}
                                                    onChange={handleEditChange}
                                                    required
                                                    // size="sm"
                                                    style={{ fontSize: '0.8rem' }}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group>
                                                <Form.Label className='fw-semibold' style={{ fontSize: '0.8rem' }}>
                                                    Show On Splash Screen <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Select
                                                    name="isSplashScreenAd"
                                                    value={editedData.isSplashScreenAd}
                                                    onChange={handleEditChange}
                                                    required
                                                    // size="sm"
                                                    style={{ fontSize: '0.8rem' }}
                                                >
                                                    <option value="" disabled>Select</option>
                                                    <option value="true">YES</option>
                                                    <option value="false">NO</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    {editedData?.isSplashScreenAd === 'false' && (
                                        <>
                                            <Row className="mb-2">
                                                <Col md={6}>
                                                    <Form.Group>
                                                        <Form.Label className='fw-semibold' style={{ fontSize: '0.8rem' }}>
                                                            Take to <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <Form.Select
                                                            name="redirectTo"
                                                            value={editedData.redirectTo || ""}
                                                            onChange={handleEditChange}
                                                            required
                                                            // size="sm"
                                                            style={{ fontSize: '0.8rem' }}
                                                        >
                                                            <option value="" disabled>Select</option>
                                                            <option value="SUBSCRIPTION">SUBSCRIPTION_SCREEN</option>
                                                            <option value="PRODUCT">PRODUCT_SCREEN</option>
                                                            <option value="MENU">MENU_SCREEN</option>
                                                            <option value="PROFILE">PROFILE_SCREEN</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                                <Col md={6}>
                                                    <Form.Group>
                                                        <Form.Label className='fw-semibold' style={{ fontSize: '0.8rem' }}>
                                                            Make Subscription Ad
                                                        </Form.Label>
                                                        <Form.Select
                                                            name="isSubscriptionAd"
                                                            value={editedData.isSubscriptionAd}
                                                            onChange={handleEditChange}
                                                            disabled={editedData?.redirectTo !== "SUBSCRIPTION"}
                                                            // size="sm"
                                                            style={{ fontSize: '0.8rem' }}
                                                        >
                                                            <option value="" disabled>Select</option>
                                                            <option value="true">Yes</option>
                                                            <option value="false">No</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                            </Row>

                                            <Row className="mb-2">
                                                <Col md={6}>
                                                    <Form.Group controlId="editSelectMenu">
                                                        <Form.Label className="fw-semibold" style={{ fontSize: '0.8rem' }}>
                                                            Select Product <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <Select
                                                            options={productsList?.map((rm) => ({
                                                                value: rm?._id,
                                                                label: rm?.name,
                                                            }))}
                                                            name="productId"
                                                            value={selectedEditProduct}
                                                            onChange={handleEditSelectProductChange}
                                                            classNamePrefix="react-select"
                                                            isClearable
                                                            placeholder="Select Product"
                                                            isDisabled={editedData?.redirectTo !== 'PRODUCT'}
                                                            styles={customStyles}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={6}>
                                                    <Form.Group controlId="editExcludedOutlets">
                                                        <Form.Label className="fw-semibold" style={{ fontSize: '0.8rem' }}>
                                                            Excluded Outlets
                                                        </Form.Label>
                                                        <Select
                                                            isMulti
                                                            components={animatedComponents}
                                                            value={selectedEditedExcludedOutlets}
                                                            onChange={handleEditSelectChange}
                                                            options={outletData}
                                                            styles={customStyles}
                                                            placeholder="Select Excluded Outlets"
                                                            closeMenuOnSelect={false}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </>
                                    )}

                                    <Row className='mt-2'>
                                        <Col md={6}>
                                            <Form.Group controlId="editPopupStatus">
                                                <Form.Label className="fw-semibold" style={{ fontSize: '0.8rem' }}>
                                                    Select Status <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Select
                                                    onChange={handleEditChange}
                                                    name="isActive"
                                                    value={editedData?.isActive}
                                                    required
                                                    // size="sm"
                                                    style={{ fontSize: '0.8rem' }}
                                                >
                                                    <option value="">Select Status</option>
                                                    <option value="true">ACTIVE</option>
                                                    <option value="false">INACTIVE</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Modal.Body>
                                <Modal.Footer style={{ padding: '0.75rem 1rem' }}>
                                    <Button variant="secondary" 
                                        // size="sm" 
                                        onClick={handleCloseEditModal} style={{ fontSize: '0.8rem' }}
                                    >
                                        Cancel
                                    </Button>
                                    <Button variant="primary" 
                                        // size="sm" 
                                        className="fw-semibold" type='submit' style={{ fontSize: '0.8rem' }}
                                    >
                                        {isEditBtnLoading ? <Spinner size='sm' /> : 'UPDATE'}
                                    </Button>
                                </Modal.Footer>
                            </Form>
                        </Modal>
                    )}

                    {openDeleteModal ? (
                        <Modal show={openDeleteModal} onHide={handleCloseDeleteModal} backdrop="static" centered 
                        // size="sm"
                        >
                            <Modal.Header closeButton style={{ padding: '0.75rem 1rem' }}>
                                <Modal.Title style={{ fontSize: '1rem' }}>Confirm Delete</Modal.Title>
                            </Modal.Header>
                            <Modal.Body style={{ fontSize: '0.85rem', padding: '1rem' }}>
                                Are you sure you want to delete this popup advertisement? This action cannot be undone.
                            </Modal.Body>
                            <Modal.Footer style={{ padding: '0.75rem 1rem' }}>
                                <Button variant="secondary" 
                                    size="sm" 
                                    onClick={() => setOpenDeleteModal(false)} style={{ fontSize: '0.8rem' }}
                                >
                                    Cancel
                                </Button>
                                <Button variant="danger" 
                                    // size="sm" 
                                    onClick={handleDeletePopup} style={{ fontSize: '0.8rem' }}
                                >
                                    {isDeleteBtnLoading ?
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            // size="sm"
                                            role="status"
                                            aria-hidden="true"
                                        /> :
                                        "Delete"
                                    }
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    ) : null}

                    {openImageModal && (
                        <Modal show={openImageModal} onHide={handleCloseImageModal} backdrop="static" centered size="md">
                            <Modal.Header closeButton style={{ padding: '0.75rem 1rem', backgroundColor: "#F5F5F5" }}>
                                <Modal.Title style={{ fontSize: '1rem' }}>Preview</Modal.Title>
                            </Modal.Header>
                            <Modal.Body style={{ padding: '1rem' }}>
                                {selectedImage ? (
                                    <>
                                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                                            {selectedImage?.advertisementImage?.match(/\.(mp4|webm|ogg|mov)$/i) ? (
                                                <video
                                                    src={selectedImage?.advertisementImage}
                                                    controls
                                                    className="img-fluid"
                                                    style={{ maxHeight: "50vh", width: '100%' }}
                                                />
                                            ) : (
                                                <img
                                                    src={selectedImage?.advertisementImage}
                                                    alt="preview"
                                                    className="img-fluid"
                                                    style={{ maxHeight: "50vh" }}
                                                />
                                            )}
                                        </div>

                                        <hr className="my-2" />
                                        <Button
                                            variant="primary"
                                            // size="sm"
                                            className="mt-1"
                                            style={{ fontSize: '0.8rem' }}
                                            onClick={() =>
                                                handleImageUploadModal({
                                                    advertisementImage: selectedImage?.advertisementImage,
                                                    _id: selectedImage?._id,
                                                })
                                            }
                                        >
                                            Change File
                                        </Button>
                                    </>
                                ) : (
                                    <>
                                        <p style={{ fontSize: '0.85rem' }}>No File Available. Upload a File.</p>
                                        <Button variant="primary" 
                                            // size="sm" 
                                            className="mt-1" style={{ fontSize: '0.8rem' }}
                                        >
                                            Upload File
                                        </Button>
                                    </>
                                )}
                            </Modal.Body>
                        </Modal>
                    )}

                    {openImageUploadModal && (
                        <Modal
                            show={openImageUploadModal}
                            onHide={() => setOpenImageUploadModal(false)}
                            centered
                            backdrop="static"
                            size="md"
                        >
                            <Modal.Header closeButton style={{ padding: '0.75rem 1rem' }}>
                                <Modal.Title style={{ fontSize: '0.8rem' }}>UPDATE FILE</Modal.Title>
                            </Modal.Header>
                            <Form onSubmit={handleEditImage}>
                                <Modal.Body style={{ padding: '1rem' }}>
                                    <Form.Group controlId="formFileUpload">
                                        <Form.Label style={{ fontSize: '0.8rem' }}>
                                            Choose File <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Control
                                            type="file"
                                            onChange={handleEditImageChange}
                                            required
                                            // size="sm"
                                            style={{ fontSize: '0.8rem' }}
                                            accept="image/*,video/*"
                                        />
                                        <Form.Text className="text-muted" style={{ fontSize: '0.7rem' }}>
                                            Supported formats: Images (png, jpg, jpeg, webp, gif) and Videos (mp4, mov, avi, mkv, webm)
                                        </Form.Text>
                                    </Form.Group>
                                </Modal.Body>
                                <Modal.Footer style={{ padding: '0.75rem 1rem' }}>
                                    <Button variant="secondary" 
                                        // size="sm" 
                                        onClick={() => setOpenImageUploadModal(false)} style={{ fontSize: '0.8rem' }}
                                    >
                                        Cancel
                                    </Button>
                                    <Button variant='primary' 
                                        // size="sm" 
                                        type='submit' style={{ fontSize: '0.8rem' }}
                                    >
                                        {isImageEditBtnLoading ? <Spinner size='sm' /> : "SAVE"}
                                    </Button>
                                </Modal.Footer>
                            </Form>
                        </Modal>
                    )}
                </div>
            </div>
        </React.Fragment>
    )
}

export default PopupAdvertisement;